<div fxLayout="row" fxLayoutAlign="center center" id="app-bottom-nav">

    <div fxFlex="50" class="nav-icon" *ngFor="let item of navItems; index as id"
        [class.active]="id === selectedId" (click)="changeRoute(id)">
        <mat-icon [svgIcon]="id === selectedId ? item.iconName + '-active' : item.iconName"></mat-icon>
        <span></span>
        <p *ngIf="id === selectedId">{{item.text}}</p>
    </div>

</div>